/*
  Banda del Cyber Monday en las tarjetas de producto (03/11/2026).

  A cada tarjeta que tiene alguna variante con precio tachado le agrega, debajo de la lista de
  variantes, una banda violeta con el logo del Cyber Monday y un contador de días, horas y
  minutos hasta el final de la promoción. Pasada la fecha la banda desaparece.

  Se carga desde `sections/binco-nav.liquid`, que está en todas las páginas. Las tarjetas que
  aparecen después (página siguiente, filtros) se atienden con un MutationObserver.
*/
(() => {
  // Del 02/11 al 14/11 de 2026, hora de Uruguay (UTC-3)
  const START = Date.parse('2026-11-02T00:00:00-03:00');
  const END = Date.parse('2026-11-14T23:59:59-03:00');
  const LOGO = window.BINCO_CYBER_LOGO || '';

  const pad = (n) => String(n).padStart(2, '0');

  const parts = (ms) => {
    const sec = Math.max(0, Math.floor(ms / 1000));
    return {
      d: Math.floor(sec / 86400),
      h: Math.floor((sec % 86400) / 3600),
      m: Math.floor((sec % 3600) / 60),
      s: sec % 60,
    };
  };

  const cell = (key, label) =>
    `<span class="binco-cyber__cell"><b data-k="${key}">00</b><i>${label}</i></span>`;

  const build = () => {
    const el = document.createElement('div');
    el.className = 'binco-cyber';
    el.innerHTML =
      '<div class="binco-cyber__top">' +
      (LOGO ? `<img class="binco-cyber__logo" src="${LOGO}" alt="Cyber Monday" width="400" height="261" loading="lazy">` : '') +
      '<span class="binco-cyber__text">ESTO EST\u00c1 EN OFERTA</span>' +
      '</div>' +
      '<div class="binco-cyber__clock" role="timer" aria-label="Tiempo que queda de oferta">' +
      cell('d', 'D\u00cdAS') + cell('h', 'HORAS') + cell('m', 'MIN') + cell('s', 'SEG') +
      '</div>';
    return el;
  };

  const paint = (el, ms) => {
    const t = parts(ms);
    el.querySelector('[data-k="d"]').textContent = pad(t.d);
    el.querySelector('[data-k="h"]').textContent = pad(t.h);
    el.querySelector('[data-k="m"]').textContent = pad(t.m);
    el.querySelector('[data-k="s"]').textContent = pad(t.s);
  };

  // Contadores sueltos (por ejemplo el de la cinta de arriba): cualquier elemento con
  // data-binco-countdown="<fecha ISO con zona horaria>" se llena y corre cada segundo.
  const tickClocks = () => {
    document.querySelectorAll('[data-binco-countdown]').forEach((el) => {
      const end = Date.parse(el.dataset.bincoCountdown);
      if (Number.isNaN(end)) return;
      const left = end - Date.now();
      if (left <= 0) {
        if (el.innerHTML) el.innerHTML = '';
        return;
      }
      const t = parts(left);
      const html =
        `<span class="binco-clock__u"><b>${pad(t.d)}</b>d</span>` +
        `<span class="binco-clock__u"><b>${pad(t.h)}</b>h</span>` +
        `<span class="binco-clock__u"><b>${pad(t.m)}</b>m</span>` +
        `<span class="binco-clock__u"><b>${pad(t.s)}</b>s</span>`;
      if (el.innerHTML !== html) el.innerHTML = html;
    });
  };

  const inWindow = () => {
    const now = Date.now();
    return now >= START && now < END;
  };

  const attach = (root) => {
    if (!inWindow()) return;
    root.querySelectorAll('.binco-card-opts').forEach((list) => {
      if (!list.querySelector('.binco-card-opt__was')) return;
      if (list.closest('.product-card__content')?.querySelector('.binco-cyber')) return;
      const el = build();
      paint(el, END - Date.now());

      // La banda va como hija directa de la tarjeta, no dentro del bloque de las variantes:
      // así el CSS la pega abajo, junto al botón, y quedan alineadas entre tarjetas.
      let host = list;
      while (host.parentElement && !host.parentElement.classList.contains('product-card__content')) {
        host = host.parentElement;
      }
      if (host.parentElement) host.after(el);
      else list.after(el);
    });
  };

  const tick = () => {
    if (!inWindow()) {
      document.querySelectorAll('.binco-cyber').forEach((el) => el.remove());
      return;
    }
    const left = END - Date.now();
    document.querySelectorAll('.binco-cyber').forEach((el) => paint(el, left));
  };

  /*
    Alineación de tarjetas: en una misma fila, cada sección de la tarjeta (precio, nombre, bajada,
    variantes y banda) se estira hasta el alto de la más alta, así lo que sigue empieza a la misma
    altura en todas. Se hace midiendo porque el alto de cada tarjeta depende de la cantidad de
    variantes y de la descripción de cada producto.
  */
  const sections = (content) => {
    const kids = Array.from(content.children);
    const at = kids.findIndex((k) => k.querySelector?.('.binco-card-opts') || k.classList.contains('binco-card-opts'));
    if (at < 0) return [];
    const end = kids[at + 1]?.classList.contains('binco-cyber') ? at + 1 : at;
    return kids.slice(0, end + 1);
  };

  // Posición y alto de layout: no cambian con el sacudón (transform) de la tarjeta, a diferencia
  // de getBoundingClientRect, que mide la tarjeta ya inclinada.
  const layoutTop = (el) => {
    let y = 0;
    for (let n = el; n; n = n.offsetParent) y += n.offsetTop;
    return y;
  };

  const align = () => {
    const contents = Array.from(document.querySelectorAll('.product-card__content'));
    contents.forEach((c) =>
      Array.from(c.children).forEach((k) => {
        if (k.dataset.binAlign) {
          k.style.minHeight = '';
          delete k.dataset.binAlign;
        }
      })
    );

    // Se agrupan por lista y por fila (misma altura en la página)
    const groups = new Map();
    contents.forEach((c) => {
      const list = c.closest('.resource-list__carousel, .product-grid, .resource-list') || document.body;
      const top = Math.round(layoutTop(c));
      const key = top;
      if (!groups.has(list)) groups.set(list, new Map());
      const rows = groups.get(list);
      if (!rows.has(key)) rows.set(key, []);
      rows.get(key).push(c);
    });

    groups.forEach((rows) =>
      rows.forEach((row) => {
        if (row.length < 2) return;
        const lists = row.map(sections);
        const n = lists[0].length;
        if (!n || lists.some((l) => l.length !== n)) return;
        for (let i = 0; i < n; i++) {
          const max = Math.max(...lists.map((l) => l[i].offsetHeight));
          lists.forEach((l) => {
            if (l[i].offsetHeight < max) {
              l[i].style.minHeight = `${max}px`;
              l[i].dataset.binAlign = '1';
            }
          });
        }
      })
    );
  };

  const init = () => {
    attach(document);
    align();
    tickClocks();
    setInterval(() => {
      tick();
      tickClocks();
    }, 1000);

    let queued = false;
    const refresh = () => {
      if (queued) return;
      queued = true;
      requestAnimationFrame(() => {
        queued = false;
        attach(document);
        align();
      });
    };

    // Los números del contador cambian cada segundo: eso no altera el alto de nada, así que no se realinea.
    new MutationObserver((records) => {
      if (records.every((r) => r.target.closest && r.target.closest('.binco-cyber__clock, [data-binco-countdown]'))) return;
      refresh();
    }).observe(document.body, { childList: true, subtree: true });
    window.addEventListener('resize', refresh);
    window.addEventListener('load', refresh);
    if (document.fonts?.ready) document.fonts.ready.then(refresh);
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
